module.exports = __webpack_public_path__ + "img/abs_s.b4ba6ff9.png";